import { useEffect, useState } from 'react'
import { SUPPLIER_PATH, getPageSuppliers } from '../../api/supplierApi'
import { useApiProgress } from '../../hooks/ApiProgress'
import useFirstRender from '../../hooks/FirstRender'
import Input from '../../components/Input'
import Textarea from '../../components/Textarea'
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi'
import { LOCATION_PATH, getPageLocations } from '../../api/locationApi'
import { formatNumber, formatNumber4Digits, onChange } from '../../utils/functions'
import { FaPlus } from "react-icons/fa";
import { toast } from 'react-toastify'
import { AiFillDelete, AiFillEdit } from 'react-icons/ai'
import Button from '../../components/Button'
import { addPurchase } from '../../api/purchaseApi'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import { useDispatch } from 'react-redux'
import { addPurchaseAction } from '../../redux/feature/purchaseSlice'
import { useCloseTab } from '../../components/tabs/TabsContext'
import SupplierPicker from '../../components/supplier/SupplierPicker'
import ProductPicker from '../../components/product/ProductPicker'
import LocationPicker from '../../components/location/LocationPicker'
import ProductLabel from '../../components/product/ProductLabel'

const PurchaseAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const [purchase, setPurchase] = useState({
        supplier: null
    })
    const dispatch = useDispatch()
    const closeTab = useCloseTab()
    const [rolls, setRolls] = useState([]);
    const [newRoll, setNewRoll] = useState({
        product: undefined,
        location: undefined,
        boilerCode: "",
        quantity: "",
        unitPrice: "",
        unitCost: "",
        parity: ""
    });

    const [errors, setErrors] = useState({})

    const [supplierPage, setSupplierPage] = useState({
        content: []
    });
    const [productPage, setProductPage] = useState({
        content: []
    });
    const [locationPage, setLocationPage] = useState({
        content: []
    });
    const isFirstRender = useFirstRender()

    const [supplierQuery, setSupplierQuery] = useState('')
    const [productQuery, setProductQuery] = useState('')
    const [locationQuery, setLocationQuery] = useState('')

    const [searchTimerSupplier, setSearchTimerSupplier] = useState();
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const [searchTimerLocation, setSearchTimerLocation] = useState();

    const pendingApiCallSupplier = useApiProgress('get', `${SUPPLIER_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const pendingApiCallLocation = useApiProgress('get', `${LOCATION_PATH}/page`, false)

    const searchingSupplier = async (params) => {
        if (searchTimerSupplier) clearTimeout(searchTimerSupplier);
        let timer = setTimeout(() => {
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(res.data)
                })
        }, 500);
        setSearchTimerSupplier(timer);
    }

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    const searchingLocation = async (params) => {
        if (searchTimerLocation) clearTimeout(searchTimerLocation);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    setLocationPage(res.data)
                })
        }, 500);
        setSearchTimerLocation(timer);
    }

    const onClickLoadMoreSupplier = () => {
        if (!supplierPage.last) {
            loadSuppliers({ search: supplierQuery, lastId: supplierPage.content[supplierPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreLocation = () => {
        if (!locationPage.last) {
            loadLocations({ search: locationQuery, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }

    const loadSuppliers = (params) => {
        !pendingApiCallSupplier &&
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadLocations = (params) => {
        !pendingApiCallLocation &&
            getPageLocations(params)
                .then(res => {
                    setLocationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingSupplier({ search: supplierQuery })
    }, [supplierQuery])

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        !isFirstRender && searchingLocation({ search: locationQuery })
    }, [locationQuery])

    useEffect(() => {
        loadSuppliers({ size: 20 })
        loadProducts({ size: 20 })
        loadLocations({ size: 20 })
    }, [])

    const onClickAddNewRoll = () => {
        if (newRoll.product && newRoll.location && newRoll.quantity && newRoll.unitPrice && purchase.parity) {
            const body = {
                ...newRoll,
                unitCost: newRoll.unitPrice / purchase.parity
            }
            setRolls(prevState => ([...prevState, body]))
            setErrors(prevState => ({ ...prevState, rolls: undefined }))
        } else {
            toast.error("Ürün, lokasyon, metre, birim fiyat ve parite boş olamaz")
        }
    }

    const onClickEditRoll = (roll, index) => {
        setNewRoll(roll)
        onClickRemoveRoll(index)
    }

    const onClickRemoveRoll = (index) => {
        setRolls(prevState => (prevState.filter((r, i) => i !== index)))
    }

    const onSubmit = () => {
        const rollsBody = rolls.map(roll => {
            return {
                productId: roll.product.id,
                quantity: roll.quantity,
                locationId: roll.location.id,
                boilerCode: roll.boilerCode,
                unitPrice: roll.unitPrice,
                unitCost: roll.unitCost
            }
        })
        const body = {
            purchaseDate: purchase.purchaseDate,
            parity: purchase.parity,
            invoiceNumber: purchase.invoiceNumber,
            vat: purchase.vat,
            supplierId: purchase.supplier?.id,
            currency: purchase.supplier?.currency,
            description: purchase.description,
            rolls: rollsBody
        }
        addPurchase(body)
            .then(res => {
                dispatch(addPurchaseAction(res.data))
                toast.success("Satın alım kaydedildi")
                closeTab()
            })
            .catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    useEffect(() => {
        setRolls(prevState => prevState.map((roll) => {
            return {
                ...roll,
                unitCost: roll.unitPrice / purchase.parity
            }
        }))
    }, [purchase.parity])

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Yeni Satın Alım</label>
            </div>
            <div className='grid grid-cols-12 gap-x-3'>
                {/* SUPPLIER PICKER */}
                <SupplierPicker
                    label='Tedarikçi'
                    pendingApiCall={pendingApiCallSupplier}
                    state={purchase.supplier}
                    setState={(value) => setPurchase(prevState => ({ ...prevState, supplier: value }))}
                    query={supplierQuery}
                    setQuery={setSupplierQuery}
                    error={errors.supplierId}
                    page={supplierPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, supplierId: undefined }))}
                    onClickClear={() => setPurchase(prevState => ({ ...prevState, supplier: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreSupplier()}
                />
                <div className='col-span-2'>
                    <Input
                        name='purchaseDate'
                        label='Satın Alım Tarihi'
                        type='date'
                        value={purchase.purchaseDate}
                        error={errors?.purchaseDate}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumber'
                        label='Fatura Numarası'
                        type='text'
                        value={purchase.invoiceNumber}
                        error={errors?.invoiceNumber}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Fatura numarası girin...'
                    />
                </div>
                <div className='col-span-1'>
                    <Input
                        name='vat'
                        label='Vergi (%)'
                        type='number'
                        value={purchase.vat}
                        error={errors?.vat}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Vergi'
                    />
                </div>
                <div className='col-span-1'>
                    <Input
                        name='parity'
                        label='Parite'
                        type='number'
                        error={errors?.parity}
                        value={purchase.parity}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Parite'
                    />
                </div>
                <div className='col-span-3'>
                    <Textarea
                        name='description'
                        label='Açıklama'
                        type='text'
                        value={purchase.description}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Açıklama girin' />
                </div>
            </div>
            <table className='w-full text-left text-zinc-900 mb-3'>
                <thead className='text-xs uppercase tracking-wide sticky top-0 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>#</th>
                        <th className='p-2 w-3/12'>Ürün</th>
                        <th className='p-2 w-2/12'>Lokasyon</th>
                        <th className='p-2 w-2/12 '>Kazan No</th>
                        <th className='p-2 w-1/12'>Metre</th>
                        <th className='p-2 w-1/12 normal-case'>{`BİRİM FİYAT ${purchase.supplier ? `(${purchase.supplier.currency}/m)` : ""}`}</th>
                        <th className='p-2 w-1/12 normal-case'>{`BİRİM MALİYET (USD/m)`}</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rolls.map((roll, index) => (
                            <tr key={index} className='border-b items-center text-sm'>
                                <td className='p-2'>
                                    <span className='text-xs'>#</span> {index + 1}
                                </td>
                                <td className='p-2'>{<ProductLabel state={roll.product} />} </td>
                                <td className='p-2'>{roll.location?.name}</td>
                                <td className='p-2'>{roll.boilerCode}</td>
                                <td className='p-2'>{formatNumber(roll.quantity)} m</td>
                                <td className='p-2'>{formatNumber(roll.unitPrice)} <span className='text-xs'>{purchase.supplier ? `${purchase.supplier?.currency}/m` : ""}</span> </td>
                                <td className='p-2'>{formatNumber4Digits(roll.unitCost)} <span className='text-xs'>USD/m</span></td>
                                <td className='p-2 flex gap-x-3'>
                                    <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => onClickEditRoll(roll, index)}>
                                        <AiFillEdit />
                                    </span>
                                    <span
                                        className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                        onClick={() => {

                                            onClickRemoveRoll(index)
                                        }}
                                    >
                                        <AiFillDelete />
                                    </span>
                                </td>
                            </tr>
                        ))
                    }
                    <tr className='text-sm' >
                        <td className='p-2'>TOPLAM</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className='p-2'>{formatNumber(rolls.reduce((a, c) => (a + Number(c.quantity)), 0))} m </td>
                        <td className='p-2'> {formatNumber(rolls.reduce((a, c) => a + Number(c.quantity * c.unitPrice), 0))} {purchase.supplier ? `${purchase.supplier?.currency}` : ""}</td>
                    </tr>
                    <tr>
                        <td>

                        </td>
                        <td>
                            {/* PRODUCT PICKER */}
                            <ProductPicker
                                //label='Ürün'
                                pendingApiCall={pendingApiCallProduct}
                                state={newRoll.product}
                                setState={(value) => setNewRoll(prevState => ({ ...prevState, product: value }))}
                                query={productQuery}
                                setQuery={setProductQuery}
                                error={errors.productId}
                                page={productPage}
                                setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                                //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                onClickLoadMore={() => onClickLoadMoreProduct()}
                            />

                        </td>
                        <td>
                            {/* LOCATION PICKER */}
                            <LocationPicker
                                //label='Ürün'
                                pendingApiCall={pendingApiCallLocation}
                                state={newRoll.location}
                                setState={(value) => setNewRoll(prevState => ({ ...prevState, location: value }))}
                                query={locationQuery}
                                setQuery={setLocationQuery}
                                error={errors.locationId}
                                page={locationPage}
                                setErrors={() => setErrors(prevState => ({ ...prevState, locationId: undefined }))}
                                //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                onClickLoadMore={() => onClickLoadMoreLocation()}
                            />
                        </td>
                        <td>
                            <Input
                                name="boilerCode"
                                onChange={e => onChange(e, setNewRoll)}
                                value={newRoll.boilerCode}
                                placeholder='Kazan no girin...'
                            />
                        </td>
                        <td>
                            <Input
                                type='number'
                                name="quantity"
                                onChange={e => onChange(e, setNewRoll)}
                                placeholder='Metre...'
                                value={newRoll.quantity}
                            />
                        </td>
                        <td>
                            <Input
                                type='number'
                                name="unitPrice"
                                onChange={e => onChange(e, setNewRoll)}
                                placeholder='Birim fiyat...'
                                value={newRoll.unitPrice}
                            />
                        </td>
                        <td>

                        </td>

                        <td>
                            <div className='flex gap-x-3 pl-5'>
                                <FaPlus className='mb-3 cursor-pointer' onClick={onClickAddNewRoll} />
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
            {errors?.rolls && <label className='text-red-700'>{errors?.rolls} </label>}

            <div className='flex justify-center'>
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onSubmit}
                />
            </div>

        </div>
    )
}

export default PurchaseAddPage